/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosHeaders } from "axios";
import { appEntity, toast } from "../entities/app.entity";
import { authEntity, clearAuth } from "../entities/auth.entity";
import { MethodType, ResponseType } from "./services.types";

let currentAbortController: AbortController | null = null;

export const fetchFromApi = ({
  path,
  method = "get",
  body,
  params,
  respType,
}: {
  path: string;
  method?: MethodType;
  body?: any;
  params?: any;
  respType?: ResponseType;
}) => {
  const requestConfig: {
    url: string;
    method: MethodType;
    data?: any;
    headers?: any;
    params?: any;
  } = { url: path, method };

  if (method !== "get" && body) requestConfig.data = body;
  if (params) requestConfig.params = params;

  const token: string = authEntity.get()?.token ?? "";
  const baseApi: string = appEntity.get()?.baseApi ?? "";
  currentAbortController = new AbortController();

  return axios({
    baseURL: baseApi,
    headers: {
      ...AxiosHeaders,
      Authorization: `Bearer ${token}`,
      ...requestConfig.headers,
    },
    ...requestConfig,
    ...(respType && { responseType: respType }),
    signal: currentAbortController.signal,
  });
};

export const handleFetchError = (err: any) => {
  if (err.response?.data?.message) toast(err.response.data.message, "error");
  if (err.response?.status === 401) clearAuth();
};
